/* eslint-disable comma-dangle */
const italian = {
    auth_login: 'Login',
    auth_logout: 'Logout',
    loading: 'In Caricamento...',
    auth_insert_username: 'Inserisci il tuo Username',
    auth_insert_password: 'Inserisci la password',
    auth_enter_email: 'Inserisci il tuo username per recuperare la password',
    auth_forgot_password: 'Hai dimenticato la password?',
    auth_continue_login: 'Vai alla login',
    auth_password_match: 'Le password non coincidono',
    auth_reset_password: 'Resetta la password',
    auth_confirm_password: 'Conferma password',
    common_email: 'Email',
    common_username: 'Username',
    common_password: 'Password',
    common_name: 'Nome',
    common_last_name: 'Cognome',
    common_insert_name: 'Inserisci il nome del minore',
    common_back: 'Indietro',
    common_birthday: 'Data di nascita ',
    common_birthplace: 'Luogo di nascita ',
    common_citizenship: 'Cittadinanza',
    common_insert_birthday: 'Inserisci la data di nascita ',
    common_pin: 'PIN',
    common_insert_pin: 'Inserisci il pin',
    common_insert: ' Inserisci',
    common_continue: 'Prosegui',
    common_user_or_email: 'Username o Email',
    common_postal: 'CAP',
    common_province: 'Provincia',
    common_notes: 'Note particolari',
    common_diseases: 'Patologie',
    common_city: 'Citta',
    common_street_number: 'Civico',
    common_street: 'Via',
    common_fraction: 'Frazione',
    common_resident: 'Residente',
    common_special: 'Speciale',
    common_special_info: 'Informazioni particolari',
    common_general: 'Generica',
    common_add_special: 'Aggiungi entrata speciale per oggi',
    common_daily_validity: 'Con validità giornaliera. A fine giornata si resetta',
    common_none: 'Nessuna',
    common_left: 'Usciti',
    common_without_appeal: 'Senza appello',
    common_with_alarm: 'Con allarme',
    common_change_password: 'Cambia Password',
    kids_calendar: 'Calendario Minore',
    kids_my_kids: 'I miei bambini',
    kids_other_kids: 'Gli altri bambini',
    kids: 'Bambini',
    kids_list: 'Lista Bambini',
    kids_other_features: 'Altre funzioni',
    kids_profile: 'Profilo Bambino',
    kids_time: 'Fascia oraria',
    kids_accompanied: 'in cui verrà abitualmente accompagnato il bambino',
    kids_accompanied_to: 'Oggi verrà accompagnato alle',
    kids_usually_accompanied: 'Abiltualmente il bambino viene accompagnato',
    kids_allergies: 'Allergie/Intolleranze',
    class: 'Classe',
    class_on_hold: 'In attesa',
    class_present: 'Presenti',
    class_teacher: 'Insegnante',
    class_list: 'Elenco Classe',
    class_appeal: 'Appello',
    class_mensa: 'Mensa',
    class_absence: 'Assenza',
    class_absence_reported: 'Assenza segnalata da',
    class_absence_justified: 'SEGNA ASSENZA GIUSTIFICATA',
    remove_class_absence_justified: 'RIMUOVI ASSENZA GIUSTIFICATA',
    profile_data: 'Anagrafica',
    profile_data_kid: 'Anagrafica bambino',
    profile_fiscal_code: ' Codice fiscale',
    profile_username: 'Username',
    profile_insert_fiscal: 'Inserisci il codice fiscale per associare un componente',
    profile_associate: 'Associa',
    token_failed: 'Verifica Fallita, riprovare oppure contattare il servizio clienti',
    profile_mobile: 'Telefono contatto',
    profile_phone: 'Contatto mobile',
    associate_error: 'Dati non validi: verificare che lo username o la mail siano validi',
    family: 'Nucleo Familiare',
    family_relationship: 'Parentela',
    family_adm: 'Amministratore',
    family_contacts: 'Contatti nucleo familiare',
    homepage: 'Homepage',
    parent: 'Genitore',
    calendar: 'Calendario',
    error_wrong_credentials: 'Credenziali errate',
    error_user_not_found: 'Utente non trovato',
    emergency_phone: 'Numero di emergenza',
    kids_in_class: 'Bimbi in classe',
    total: 'Totale classe',
    showReferences: 'Fai vedere i miei riferimenti',
    dontShowReferences: 'Non fai vedere i miei riferimenti',
    areYouSureToConfirmAbsenceModal: 'Sei sicuro di voler Segnare l\'assenza giustificata ? ',
    areYouSureToRemoveAbsenceModal: 'Sei sicuro di voler Eliminare l\'assenza giustificata del',
    yes: 'Sì',
    no: 'No',
    generica: 'Generica',
    choose_language: 'Scegli lingua:',
    english: 'Inglese',
    italian: 'Italiano',
    scanner_qr_code: 'Scansione QR Code',
    scan_qr_code_of: 'Scansiona il QR Code di',
    to_mark_presence: 'per segnarne la presenza all’asilo.',
    something_went_wrong: 'qualcosa è andato storto, prova di nuovo a scansionare il QR Code!',
    scan: 'Scansiona',
    errorScanMessage: 'Non è possibile inizializzare lo scannner per problemi di permessi',
    well_done: 'Ben fatto!',
    successfully_scanned_arrived: 'Hai scansionato con successo la presenza all’asilo!',
    successfully_scanned_left: 'Hai scansionato con successo l\'uscita dall’asilo!',
    ops: 'Ops',
    close_camera_to_qr_code: 'Avvicinare la fotocamera al QrCode e attendere l\'esito dello scan',
    present: 'presente',
    absent: 'assente',
    uscita: 'uscita',
    waiting_to_enter: 'in attesa di entrare',
    present_to_family: 'presente per la famiglia',
    on_hold: 'in attesa',
    attention: 'ATTENZIONE',
    exit: 'uscito',
    closed_school: 'asilo chiuso',
    entered_at: 'entrato alle:',
    released_at: 'uscito alle:',
    time_limit: 'orario limite:',
    absent_justified: 'assente giustificato',
    time_limit_exceeded: 'orario limite superato',
    language: 'Lingua',
    kids_number: 'Numero di bambini',
    customer_care: 'Numero verde',
    home: 'Home',
    edit_profile: 'Modifica profilo',
    chat_not_available: 'La funzionalità sarà attivata al più presto',
    january: 'Gennaio',
    february: 'Febbraio',
    march: 'Marzo',
    april: 'Aprile',
    may: 'Maggio',
    june: 'Giugno',
    july: 'Luglio',
    august: 'Agosto',
    september: 'Settembre',
    october: 'Ottobre',
    november: 'Novembre',
    december: 'Dicembre',
    today: 'Oggi',
    login_failed: 'LOGIN FALLITO - email o password errate',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Gio',
    fri: 'Ven',
    sat: 'Sab',
    sun: 'Dom',
    emergency_call_answered: 'Risposta a chiamata d\'emergenza',
    emergency_call_no_answer: 'Chiamata di emergenza senza risposta',
    emergency_call_forwarded: 'Tentativo di chiamata d\'emergenza',
    presence_confirmed: 'Presenza Confermata',
    expected_absence_signaled: 'Segnalazione d\'assenza giustificata',
    arrival_time_exception: 'Segnalazione orario d\'arrivo straordiario',
    danger_status: 'Stato di pericolo',
    max_danger_status: 'Stato di massimo pericolo',
    qr_minor_arrived: 'Timbro minore consegnato',
    qr_minor_left: 'Timbro uscita minore',
    arrival_time_exception_updated: 'Orario d\'arrivo straordinario modificato',
    arrival_time_updated: 'Orario d\'arrivo modificato',
    minor_absence_teacher: 'Assenza segnalata da insegnante',
    no_tutor_answered: 'Nessuna risposta alle chiamate',
    minor_left_class: 'Conferma uscita dalla classe',
    tutors_sms_sent: 'SMS inviato ai Tutor',
    admin: 'Admin',
    participants: 'Nessuno | 1 partecipante | {count} partecipanti',
    write_message: 'Scrivi un messaggio',
    and: 'e',
    register: 'Registro',
    entry: 'entrata',
    communication: 'Comunicazioni',
    group_administrator: 'Amministratore gruppo',
    teacher: 'Maestra',
    unread_messages: '{count} messaggio non letto | {count} messaggi non letti',
    inbox: 'In Arrivo',
    outbox: 'In Uscita',
    new_message: 'Nuovo messaggio',
    entry_message: 'Messaggio in arrivo',
    subject: 'Oggetto',
    search: 'Cerce',
    yesterday: 'Ieri',
    this_weekend: 'Questa settimana',
    older: 'Più vecchio',
    no_result: 'Nessun elemento trovato.',
    send_to_all: 'Invia a tutti',
    send_specific: 'Invia a destinatari',
    minors: 'Minori',
    scheduled_absences: 'Assenze programmate',
    scheduled: 'Programmata',
    from: 'Da',
    of: 'del',
    to: 'A',
    confirm_absence: 'Conferma assenza',
    notValidTaxCode: 'Codice fiscale non valido',
    userAlreadyAssociated: 'Utente già associato',
    userNotTutor: 'L\'utente non è di tipo "Tutor"',
    generalError: 'Errore generale',
    done: 'Fatto',
    unexpectedError: 'Si è verificato un errore imprevisto, si prega di riprovare!',
    select: 'Seleziona',
    selected: 'Selezionato',
    areYouSureToDeleteEmailModal: 'Sei sicuro di voler eliminare questa email?'
};

export default italian;
